import { requestTypeConstant } from '../components/fseManagementSystem/components/serviceFlow/Constants/constant';

const getAddressString = (merchantAddress, requestType) => {
  const fields = {
    address: ['shopName', 'line1', 'landmark', 'city'],
    cpv: [
      'shopName',
      'line1',
      'line2',
      'landmark',
      'city',
      'state',
      'postalCode',
    ],
  };

  const address = [];

  let type;

  switch (requestType) {
    case requestTypeConstant.LENDING_CPV:
      type = 'cpv';
      break;

    default:
      type = 'address';
      break;
  }

  if (fields[type]) {
    fields[type].forEach((field) => {
      if (merchantAddress?.[field]) {
        address.push(merchantAddress[field]);
      }
    });
  }

  return address.length > 0 ? address.join(', ') : '';
};

export default getAddressString;
